import { apiRequest, apiRequests } from "../services/api";
import { GET_ALL_SUBSCRIPTIONS_ALL,GET_ALL_SUBSCRIPTIONS,VALIDATION_SUBCRIPTION_TECHNICIAN , GET_RECORD_TECHNICIAN , GET_ALL_SUBCRIPTION_PLAIN , DETAILS_SUBCRIPTION_TECH} from "../graphql/query/suscription/query"
import { REGISTER_SUBCRIPTION_TECHNICIAN , AGG_SUBCRIPTION , LOW_SUSCRIPTION} from "../graphql/mutations/suscription/mutations";


/** QUERY'S DE SUSCRIPCIONES PARA TECHNICIANS */
export const getAllSubcriptionPlain = async() => {
    try{
        const response = await apiRequests(GET_ALL_SUBCRIPTION_PLAIN);
        if(response){
            return response.data.allSubcriptionPlain;
        }else{
            return [];
        }
    }catch(error){
        console.log('Fallas en el servidor fronted ', error);
        return null;
    }
}

export const getRecordTechnician = async(technicianId) =>{
    try{
        const variables = {
            id_technician:technicianId
        };
        const response = await apiRequests(GET_RECORD_TECHNICIAN,variables);
        return response.data.getRecordSubcriptionTechnician.suscriptionTech;
    } catch (error){
        //console.log('Lo siguiente es la falla : ',error);
        return [];
    }
}

export const getAllSubcriptionAll = async() =>{
    try {
        const response = await apiRequest(GET_ALL_SUBSCRIPTIONS_ALL)
        if(response.data.allSubcriptionAll){
            return response.data.allSubcriptionAll;
        }else{
            console.error('Surgio un problema con el servidor');
            return [];
        };
    } catch ($e) {
        console.error('Surgio un problema en el fronted', $e);
        return [];
    }
}

export const getAllSubcription = async() =>{
    try {
        const response = await apiRequest(GET_ALL_SUBSCRIPTIONS)
        if(response.data.allSuscription){
            return response.data.allSuscription;
        }else{
            console.error('Surgio un problema con el servidor');
            return [];
        };
    } catch ($e) {
        console.error('Surgio un problema en el fronted', $e);
        return [];
    }
}

export const validationSubcriptionTechnician =async (technicianId) => {
    try {
        const variables = {
            requestSubcription:{
                technicianId:technicianId
            }
        };
        const response = await apiRequest(VALIDATION_SUBCRIPTION_TECHNICIAN,variables);
        if(response.data.validationSubscription.result){
            //console.log('resp1: ',response.data.validationSubscription);
            return response.data.validationSubscription
        }else{
            //console.log('resp2: ',response.data.validationSubscription);
            return response.data.validationSubscription
        }

    }catch($e) {
        console.error('Surgio un problem en el fronted: ', $e);
        return[];
    }
}

export const getDetailsSusTech = async(subcriptionId) => {
    try {
        const variables = { suscriptionId:subcriptionId};
        const response = await apiRequests(DETAILS_SUBCRIPTION_TECH,variables);
        if (response?.data?.getLstTechnicianSuscrip) {
            return {
                success: true,
                message: response.data.getLstTechnicianSuscrip.message,
                count: response.data.getLstTechnicianSuscrip.count,
                name_sub: response.data.getLstTechnicianSuscrip.name_sub,
                content: response.data.getLstTechnicianSuscrip.content
            };
        } else {
            return { success: false, message: "No se encontraron técnicos.", count: 0, content: [] };
        }
    } catch(error){
        console.warn('Fallas en el sistema :',error)
        return null;
    }
}

/** MUTATIONS DE SUSCRIPCIONES PARA TECHNICIANS */
export const registerSubcriptionTechnician =async (technicianId,subcriptionId) => {
    try {
        const variables = {
            requestSubcription:{
                technicianId:technicianId,
                subcriptionId:subcriptionId 
            }
        }
        //console.log('variables: ', variables);
        const response = await apiRequest(REGISTER_SUBCRIPTION_TECHNICIAN,variables);
        if(response.data.registerTechnicianSubcription?.result){
            return response.data.registerTechnicianSubcription;
        }else{
            //console.log('resp2',response.data.registerTechnicianSubcription.message);
            return response.data.registerTechnicianSubcription;
        }

    } catch ($e){
        console.error('surgio un problema en el fronted:', $e);
        return [];
    }
}

export const aggSubcription = async (requestSubcription) => {
    try {
        const variables = { requestSubcription };
        const response = await apiRequests(AGG_SUBCRIPTION, variables);

        if (response && response.data && response.data.createSubcripcion) {
            return {
                success: response.data.createSubcripcion.subcription ? true : false,
                message: response.data.createSubcripcion.message || "Ocurrió un error",
                subcription: response.data.createSubcripcion.subcription || null,
            };
        } else {
            return { success: false, message: "Respuesta inválida del backend", subcription: null };
        }
    } catch (error) {
        console.error("Fallas en el frontend:", error);
        return { success: false, message: "Error en la solicitud", subcription: null };
    }
};

export const lowSubcription = async (subcriptionId) => {
    try{
        const variables = {
            requestSubcription:{
                id:subcriptionId
            }
        };
    
        const response = await apiRequests(LOW_SUSCRIPTION,variables);
        if (response?.data?.lowSubcription) {
            return {
                success: true,
                message: response.data.lowSubcription.message,
                subcription: response.data.lowSubcription.subcription
            };
        } else {
            return { success: false, message: "No se pudo cancelar la suscripción." };
        }
    } catch (error){
        console.warn('Se presento las siguientes fallas: ' , error);
        return null;
    }
}
